var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"primary pa-4",attrs:{"x-large":"","to":{name: 'Equipment'}}},[_vm._v("Equipment")])}
var staticRenderFns = []

export { render, staticRenderFns }